import React, { useCallback } from 'react';
import { VacationRentalsList } from '../VacationRentalsList';
import type { VacationRentalAreaData } from '@shared/components/VacationRentalTile/VacationRentalTile.types';
import { VacationRentalsStatus } from '../VacationRentalsStatus';
import { useVacationRentals } from '@shared/utils/vacationRentals/useVacationRentals';

export const VacationRentals: React.FC = () => {
  const { vacationRentals } = useVacationRentals();

  const handleReorder = useCallback((_reorderedRentals: ReadonlyArray<VacationRentalAreaData>) => {
    // @todo [TRAV-2250] Implement API call to save new order
  }, []);

  const handleView = useCallback((_rental: VacationRentalAreaData) => {
    // @todo [TRAV-2250] Navigate to stay area detail view
  }, []);

  const handleRemove = useCallback((_rental: VacationRentalAreaData) => {
    // @todo [TRAV-2250] Show confirmation dialog and call delete API
  }, []);

  return (
    <>
      <VacationRentalsStatus />
      <VacationRentalsList
        rentals={vacationRentals}
        onReorder={handleReorder}
        onView={handleView}
        onRemove={handleRemove}
      />
    </>
  );
};
